import React from "react";
import Contracts from "../../Contracts";
import CardSection from "../../../../components/ui/card/CardSection";
import CoveredScopes from "./features/coveredScopes/CoveredScopes";
import EfficiencyExtract from "./features/efficiencyExtract/EfficiencyExtract";
import MonthlyRevenue from "./features/monthlyRevenue/MonthlyRevenue";
import formatDate from "../../../../components/finalMolGrid/libs/formatDate";

const ContractReports = () => {
  const currentDate = formatDate(new Date(), "MM-DD-YYYY");
  return (
    <div className="contract-reports-section">
      <div className="scrollable-table-sec">
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <CardSection
                  cardTitle="Covered Scopes"
                  customHeader={true}
                >
                  <CoveredScopes currentDate ={currentDate} />
                </CardSection>
              </div>
              <div className="col-12">
                <CardSection
                  cardTitle="Monthly Revenue"
                  customHeader={true}
                >
                  <MonthlyRevenue currentDate ={currentDate} />
                </CardSection>
              </div>
            </div>
          </div>

          <div className="col-6 pl-1">
            <CardSection
              cardTitle="Efficiency Extract"
              customHeader={true}
            >
              <EfficiencyExtract currentDate ={currentDate} />
            </CardSection>
          </div>
        </div>
      </div>
    </div>
    // <UnderConstruction />
  );

};

export default Contracts(ContractReports);
